// extracted by mini-css-extract-plugin
export default {"main":"ModalExpanseImage_main__RZMYu","imgExpanse":"ModalExpanseImage_imgExpanse__+D0lu"};